export function getAnchorNavData(contentElementList) {
    if (!Array.isArray(contentElementList)) return [];

    const flattenedList = contentElementList.map((contentElement) => {
        if (!contentElement) {
            return contentElement;
        }

        const { type, ...data } = contentElement;

        if (type === "DatoCmsGlobalBlock") {
            return (data?.globalContentBlock?.contentBlock ?? [])[0] ?? {};
        }

        return contentElement;
    });

    return flattenedList.reduce((anchorLinkList, contentElement) => {
        const anchor = contentElement?.anker;

        if (!anchor) return anchorLinkList;

        return [
            ...anchorLinkList,
            {
                link: slugify(anchor),
                label: anchor
            }
        ];
    }, []);
}

export const slugify = (str) =>
    str
        .toLowerCase()
        .trim()
        .replace(/[ä]/g, "ae")
        .replace(/[ö]/g, "oe")
        .replace(/[ü]/g, "ue")
        .replace(/[ß]/g, "ss")
        .replace(/[^\w\s-]/g, "")
        .replace(/[\s_-]+/g, "-")
        .replace(/^-+|-+$/g, "");
